import {
  ERROR_TRIAGE_CLASSIFICATION_LABEL,
  ERROR_TRIAGE_SOURCE_LABEL,
} from '../../interfaces/errorTriage'
import { FilterFieldType, IFilter } from './types'

const SOURCE_OPTIONS = Object.entries(ERROR_TRIAGE_SOURCE_LABEL).map(([value, label]) => ({
  value,
  label,
}))

const CLASSIFICATION_OPTIONS = Object.entries(ERROR_TRIAGE_CLASSIFICATION_LABEL).map(
  ([value, label]) => ({ value, label }),
)

export const ERROR_TRIAGE_DEFAULT_SORT = 'last_seen_at'

/** The grouped Error Center table: one row per fingerprint. */
export const ERROR_TRIAGE_LIST_FILTERS_CONFIG = [
  {
    // Not sortable: the cell shows the alert title when there is one, which no
    // single column holds, so sorting by `message` would look out of order.
    field: 'message',
    dbField: 'message',
    alias: 'triage',
    type: FilterFieldType.Text,
    title: 'Error',
    align: 'left',
  },
  {
    field: 'origin',
    dbField: 'origin',
    alias: 'triage',
    type: FilterFieldType.Text,
    isSortable: true,
    title: 'Origin',
    align: 'left',
  },
  {
    field: 'source',
    dbField: 'source',
    alias: 'triage',
    type: FilterFieldType.List,
    isMultiple: true,
    isSortable: true,
    title: 'Source',
    options: SOURCE_OPTIONS,
  },
  {
    field: 'classification',
    dbField: 'classification',
    alias: 'triage',
    type: FilterFieldType.List,
    isMultiple: true,
    isSortable: true,
    title: 'Status',
    options: CLASSIFICATION_OPTIONS,
  },
  {
    field: 'occurrenceCount',
    dbField: 'occurrence_count',
    alias: 'triage',
    type: FilterFieldType.Number,
    isSortable: true,
    title: 'Occurrences',
  },
  {
    field: 'lastSeenAt',
    dbField: 'last_seen_at',
    alias: 'triage',
    type: FilterFieldType.Datetime,
    isSortable: true,
    title: 'Last seen',
  },
  // Searchable through the full-search box, not shown as columns.
  {
    field: 'lastAlertTitle',
    dbField: 'last_alert_title',
    alias: 'triage',
    type: FilterFieldType.Text,
    excludeColumn: true,
    title: 'Alert',
  },
  {
    field: 'errorName',
    dbField: 'error_name',
    alias: 'triage',
    type: FilterFieldType.Text,
    excludeColumn: true,
    title: 'Error type',
  },
  {
    field: 'errorCode',
    dbField: 'error_code',
    alias: 'triage',
    type: FilterFieldType.Text,
    excludeColumn: true,
    title: 'Error code',
  },
] as const satisfies IFilter[]

export const ERROR_OCCURRENCE_DEFAULT_SORT = 'occurred_at'

/** Individual occurrences: the drawer's table and the Live tab. */
export const ERROR_OCCURRENCE_LIST_FILTERS_CONFIG = [
  {
    field: 'occurredAt',
    dbField: 'occurred_at',
    alias: 'occurrence',
    type: FilterFieldType.Datetime,
    isSortable: true,
    title: 'Time',
    align: 'left',
  },
  {
    // Not sortable: the cell shows the alert title when there is one, which no
    // single column holds, so sorting by `message` would look out of order.
    field: 'message',
    dbField: 'message',
    alias: 'occurrence',
    type: FilterFieldType.Text,
    title: 'Error',
    align: 'left',
  },
  {
    field: 'origin',
    dbField: 'origin',
    alias: 'occurrence',
    type: FilterFieldType.Text,
    isSortable: true,
    title: 'Origin',
    align: 'left',
  },
  {
    field: 'source',
    dbField: 'source',
    alias: 'occurrence',
    type: FilterFieldType.List,
    isMultiple: true,
    isSortable: true,
    title: 'Source',
    options: SOURCE_OPTIONS,
  },
  {
    field: 'errorCode',
    dbField: 'error_code',
    alias: 'occurrence',
    type: FilterFieldType.Text,
    isSortable: true,
    title: 'Code',
  },
  {
    // Rendered from the joined user; filtering by user isn't offered.
    field: 'userName',
    type: FilterFieldType.Empty,
    title: 'User',
    align: 'left',
  },
  {
    field: 'alertTitle',
    dbField: 'alert_title',
    alias: 'occurrence',
    type: FilterFieldType.Text,
    excludeColumn: true,
    title: 'Alert',
  },
] as const satisfies IFilter[]
